"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/lib/Dropdown"));
var _dropdownToggle = require("../dropdown-toggle/dropdown-toggle");
var Dropdown = exports.Dropdown = function Dropdown(props) {
  var id = props.id,
    children = props.children,
    toggleElement = props.toggleElement,
    positionRight = props.positionRight;
  return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    id: id,
    pullRight: positionRight
  }, /*#__PURE__*/_react["default"].createElement(_dropdownToggle.DropdownToggle, {
    bsRole: "toggle"
  }, toggleElement), /*#__PURE__*/_react["default"].createElement(_Dropdown["default"].Menu, {
    className: "dropdown-menu"
  }, children));
};
Dropdown.defaultProps = {
  positionRight: false
};